import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import CafePlusPage from "@/pages/CafePlusPage";
import PlusOnePage from "@/pages/PlusOnePage";
import UpcomingEventsPage from "@/pages/UpcomingEventsPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import { CartProvider } from "@/context/CartContext";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/cafe-plus" element={<CafePlusPage />} />
            <Route path="/plus-one" element={<PlusOnePage />} />
            <Route path="/events" element={<UpcomingEventsPage />} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster 
          position="top-right" 
          duration={3000}
          closeButton
          richColors
        />
      </div>
    </CartProvider>
  );
}

export default App;